import ArchiveProgramCategory from './Main'

const route = {
  path: '/archive/program/:year/:categoryName',
  name: 'programArchiveCategory',
  meta: {
    title: 'Archive - A D M A N 2 0 1 9'
  },
  component: ArchiveProgramCategory
}

export default route
